import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo"/>
        <h1>Velachi</h1>
        <small className="App-goodbye-message">Currently under construction. Please visit us later.</small>
      </header>
    </div>
  );
}

export default App;
